export const idiomas = ["Africâner – África do Sul",
"Africâner – Namíbia",
"Aimará – Bolívia",
"Aimará – Peru",
"Albanês – Albânia",
"Albanês – Kosovo",
"Albanês – Macedônia",
"Alemão – Áustria",
"Alemão – Alemanha",
"Alemão – Bélgica",
"Alemão – Liechtenstein",
"Alemão – Luxemburgo",
"Alemão – Suíça",
"Árabe – Argélia",
"Árabe – Bahrain",
"Árabe – Chade",
"Árabe – Comores",
"Árabe – Djibouti",
"Árabe – Egito",
"Árabe – Eritreia",
"Árabe – Iraque",
"Árabe – Israel",
"Árabe – Jordânia",
"Árabe – Kuwait",
"Árabe – Líbano",
"Árabe – Líbia",
"Árabe – Mauritânia",
"Árabe – Marrocos",
"Árabe – Omã",
"Árabe – Catar",
"Árabe – Arábia Saudita",
"Árabe – Somália",
"Árabe – Sudão",
"Árabe – Síria",
"Árabe – Emirados Árabes Unidos",
"Árabe – Tunísia",
"Árabe – Sara Ocidental",
"Árabe – Iêmen",
"Arménio – Armênia",
"Azeri – Azerbaijão",
"Bielorrusso – Bielorrússia",
"Bengali – Bangladesh",
"Bislama – Vanuatu",
"Bósnio – Bósnia e Herzegovina",
"Búlgaro – Bulgária",
"Cazaque – Cazaquistão",
"Catalão – Andorra",
"Checo – República Checa",
"Chinês Mandarim – China",
"Chinês Mandarim – Hong Kong",
"Chinês Mandarim – Macau",
"Chinês Mandarim – Taiwan",
"Chinês Mandarim – Malásia",
"Chinês Mandarim – Singapura",
"Coreano – Coreia do Norte",
"Coreano – Coreia do Sul",
"Croata – Bósnia e Herzegovina",
"Croata – Croácia",
"Curdo – Iraque",
"Dinamarquês – Dinamarca",
"Dinamarquês – Ilhas Feroé",
"Dinamarquês – Groenlândia",
"Dari – Afeganistão",
"Dhiveli – Maldivas",
"Dzongkha – Butão",
"Eslovaco – Eslováquia",
"Esloveno – Eslovênia",
"Espanhol – Argentina",
"Espanhol – Bolívia",
"Espanhol – Chile",
"Espanhol – Colômbia",
"Espanhol – Costa Rica",
"Espanhol – Cuba",
"Espanhol – República Dominicana",
"Espanhol – Equador",
"Espanhol – El Salvador",
"Espanhol – Espanha",
"Espanhol – Guiné Equatorial",
"Espanhol – Guatemala",
"Espanhol – Honduras",
"Espanhol – Jamaica",
"Espanhol – México",
"Espanhol – Nicarágua",
"Espanhol – Panamá",
"Espanhol – Paraguai",
"Espanhol – Peru",
"Espanhol – Porto Rico",
"Espanhol – Uruguai",
"Espanhol – Venezuela",
"Espanhol – Saara Ocidental",
"Estoniano – Estônia",
"Fijiano – Fiji",
"Filipino – Filipinas",
"Finlandês ou finês – Finlândia",
"Francês – Bélgica",
"Francês – Burkina Faso",
"Francês – Burundi",
"Francês – Camarões",
"Francês – Canadá",
"Francês – República Centro-Africana",
"Francês – Chade",
"Francês – Comores",
"Francês – Congo",
"Francês – Congo-Brazzaville",
"Francês – República Democrática do Congo",
"Francês – Congo-Kinshasa",
"Francês – Costa do Marfim",
"Francês – Djibuti",
"Francês – Guiné Equatorial",
"Francês – França",
"Francês – Gabão",
"Francês – Guiné",
"Francês – Haiti",
"Francês – Madagáscar",
"Francês – Mali",
"Francês – Maurícia",
"Francês – Mônaco",
"Francês – Ruanda",
"Francês – Senegal",
"Francês – Seychelles",
"Francês – Suíça",
"Francês – Togo",
"Francês – Vanuatu",
"Frísio – Países Baixos",
"Georgiano – Geórgia",
"Grego – Grécia",
"Grego – Chipre",
"Guarani – Paraguai",
"Crioulo haitiano – Haiti",
"Hebreu ou hebraico – Israel",
"Hindi – Índia",
"Hindi – Fiji",
"Hiri motu – Papua-Nova Guiné",
"Holandês – Bélgica",
"Holandês – Países Baixos",
"Holandês – Suriname",
"Holandês – Antilhas Holandesas",
"Holandês – Aruba",
"Húngaro – Hungria",
"Indonésio – Indonésia",
"Inglês – Austrália",
"Inglês – Bahamas",
"Inglês – Belize",
"Inglês – Botsuana",
"Inglês – Canadá",
"Inglês – Estados Unidos",
"Inglês – Fiji",
"Inglês – Gana",
"Inglês – Guiana",
"Inglês – Índia",
"Inglês – Jamaica",
"Inglês – Quênia",
"Inglês – Kiribati",
"Inglês – Nigéria",
"Inglês – Paquistão",
"Inglês – Papua-Nova Guiné",
"Inglês – República da Irlanda",
"Inglês – África do Sul",
"Inglês – Nova Zelândia",
"Inglês – Malásia",
"Inglês – Singapura",
"Inglês – Filipinas",
"Inglês – Gâmbia",
"Inglês – Zâmbia",
"Inglês – Namíbia",
"Inglês – Trinidad e Tobago",
"Irlandês – República da Irlanda",
"Italiano – Itália",
"Italiano – Suíça",
"Italiano – San Marino",
"Italiano – Croácia",
"Italiano – Eslovênia",
"Japonês – Japão",
"Japonês – Palau",
"Canará – Índia",
"Khmer – Camboja",
"Laociano – Laos",
"Latim – Santa Sé (Cidade do Vaticano)",
"Letão – Letônia",
"Lituano – Lituânia",
"Macedônio – Macedônia",
"Malaio – Malásia",
"Malaio – Brunei",
"Malaio – Singapura",
"Malaiala – Índia",
"Maori – Nova Zelândia",
"Marata – Índia",
"Moldávio – Moldávia",
"Mongol – Mongólia",
"Mongol – China",
"Ndebele – África do Sul",
"Nepalês – Nepal",
"Sotho setentrional – África do Sul",
"Norueguês – Noruega",
"Oriá – Índia",
"Oriá – Orissa",
"Pachto – Afeganistão",
"Patoá jamaicano – Jamaica",
"Persa – Irã",
"Persa – Afeganistão",
"Persa – Tajiquistão",
"Polonês ou Polaco – Polônia",
"Português – Angola",
"Português – Brasil",
"Português – Cabo Verde",
"Português – Guiné-Bissau",
"Português – Macau",
"Português – Moçambique",
"Português – Portugal",
"Português – São Tomé e Príncipe",
"Português – Timor-Leste",
"Punjabi – Índia",
"Quíchua – Bolívia",
"Quíchua – Peru",
"Quirguiz – Quirguistão",
"Quirguiz – China",
"Romeno – Moldova",
"Romeno – Romênia",
"Romanche – Suíça",
"Russo – Ucrânia",
"Russo – Bielorrússia",
"Russo – Cazaquistão",
"Russo – Quirguizistão",
"Russo – Rússia",
"Sérvio – Bósnia e Herzegovina",
"Sérvio – Sérvia e Montenegro",
"Cingalês – Sri Lanka",
"Somali – Somália",
"Soto – África do Sul",
"Suaíli – Quênia",
"Suaíli – Tanzânia",
"Suázi – Suazilândia",
"Suázi – África do Sul",
"Sueco – Suécia",
"Tajique – Tajiquistão",
"Tâmil – Malásia",
"Tâmil – Singapura",
"Tâmil – Sri Lanka",
"Tétum – Timor-Leste",
"Tai – Tailândia",
"Tok Pisin – Papua-Nova Guiné",
"Tsonga – África do Sul",
"Tswana – África do Sul",
"Turco – Turquia",
"Turco – Chipre",
"Turcomeno – Turquemenistão",
"Ucraniano – Ucrânia",
"Uzbeque – Uzbequistão",
"Venda – África do Sul",
"Vietnamita – Vietname",
"Xhosa – África do Sul",
"Zulu – África do Sul"]
